import { types } from 'mobx-state-tree';
import { invert, isEmpty } from 'lodash';
import { formatDate, parseDate, DATE_FORMATS } from 'shared/utils/date';
import { transformSnapshot, mapSnapshotProps } from 'shared/utils/snapshot';
import { capitalizeName } from 'app/shared/utils/helpers';
import Insurer from './Insurer';
import Address from './Address';

const PRE_MAPPING = {
  firstName: 'first_name',
  lastName: 'last_name',
  memberId: 'member_id',
  ssnLastFour: 'ssn_last_four',
  isVerified: 'is_verified',
};
const POST_MAPPING = invert(PRE_MAPPING);

const Member = types
  .model('Member', {
    firstName: types.maybeNull(types.string),
    lastName: types.maybeNull(types.string),
    dob: types.maybeNull(types.Date),
    memberId: types.maybeNull(types.string),
    ssnLastFour: types.maybeNull(types.string),
    zipcode: types.maybeNull(types.string),
    employer: types.maybeNull(types.string),
    sex: types.maybeNull(types.string),
    insurer: types.maybeNull(Insurer),
    isVerified: false,
    address: types.maybeNull(Address),
  })
  .views(self => ({
    get name() {
      return [self.firstName, self.lastName].filter(Boolean).join(' ');
    },
    get uiDob() {
      return formatDate(self.dob, DATE_FORMATS.ui);
    },
  }))
  .preProcessSnapshot(transformSnapshot.pre(
    mapSnapshotProps(PRE_MAPPING),
    snapshot => ({
      ...snapshot,
      address: isEmpty(snapshot.address) ? null : snapshot.address,
      firstName: capitalizeName(snapshot.firstName),
      lastName: capitalizeName(snapshot.lastName),
      dob: parseDate(snapshot.dob, DATE_FORMATS.server),
    })
  ))
  .postProcessSnapshot(transformSnapshot.post(
    mapSnapshotProps(POST_MAPPING),
    snapshot => ({
      ...snapshot,
      dob: formatDate(snapshot.dob, DATE_FORMATS.server),
    }),
  ));

export default Member;
